// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/Variables/Variables.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/fonts/lufga.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/assets/arrow_down.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../src/assets/submit.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../src/assets/edit-ed.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../src/assets/calloff.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../src/assets/SearchBold.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===================================================
   LUFGA FONT - GLOBAL APPLICATION
   Using Plus Jakarta Sans as close alternative until Lufga files are added
   =================================================== */

/* Apply font to body */
body {
  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Apply font to all elements globally */
*,
*::before,
*::after {
  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;
}

/* Ensure headings use the font */
h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;
}

/* Ensure inputs, buttons, and form elements use the font */
input, button, select, textarea, label, span, p, div, a {
  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;
}

.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
  border: none;
  color: #303b5a !important;
  font-size: 14px !important;
  font-style: normal;
  font-weight: 600 !important;
  line-height: normal;
}
.PhoneInput {
  display: flex;
  align-items: center;
  margin-bottom: 16px !important;
}
/* .App {
  text-align: center;
} */
/* :root {
  --black: #000;
  --white: #f5f5f5;
}

body{
  background: var(--background-color);
  color: var(--text-color);
}

body.light{
  --background-color: var(--white);
  --text-color:var(--black);
}
body.dark{
  --background-color: var(--black);
  --text-color:var(--white);
} */
th:first-child {
  border-radius: 0px;
  position: unset !important;
  width: auto;
}
.rbt-input-multi .rbt-input-wrapper {
  align-items: center !important;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: -4px;
  margin-top: -1px;
  overflow: hidden;
}
.searchwrapsec .row {
  align-items: center;
}
hr {
  border-top: 1px dashed red !important;
}
.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.mr-1 {
  margin-right: 10px !important;
}
.ml-1 {
  margin-left: 10px !important;
}
.mb-20 {
  margin-bottom: 20px;
}

.cookie-banner {
  position: fixed;
  bottom: 10px;
  left: 10%;
  right: 10%;
  width: 80%;
  color: #babfc7;
  padding: 5px 9px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #050420;
  border-radius: 5px;
  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);
}

.cookie-banner p {
  margin-bottom: 0px;
  font-size: 13px;
}

.close {
  height: 30px;
  width: 130px;
  font-size: 11px;
  background-color: #32c167;
  border: none;
  color: #fff;
  border-radius: 2px;
  cursor: pointer;
}

.react-confirm-alert-overlay {
  background-color: #0e1726ba !important;
}

.react-confirm-alert-body > h1 {
  color: #0e1726e0 !important;
  text-align: center !important;
  font-size: 24px !important;
}

.react-confirm-alert-body {
  background: #fff !important;
  color: #0e1726e0 !important;
  text-align: center !important;
  font-size: 14px !important;
  font-weight: bold;
}

.react-confirm-alert-button-group {
  justify-content: center !important;
}
.react-confirm-alert-button-group > button {
  background: #131f43 !important;
  color: #fff !important;
}

.react-date-picker__wrapper {
  border: none !important;
  padding: 0px 10px;
}

/*Ag grid Table*/

.ag-theme-alpine .ag-root-wrapper {
  border: none !important;
  background: transparent !important;
  text-overflow: initial !important;
}

.ag-theme-alpine .ag-header {
  border-bottom: none !important;
  margin-bottom: 0px;
  border-radius: 5px 5px 0px 0px !important;
  min-height: 45px !important;
  border: none !important;
  text-overflow: initial !important;
  background: #131f43 !important;
}
.ag-theme-alpine .ag-row {
  height: 63px !important;
  border-radius: 0px !important;
  padding-top: 0px !important;
  font-size: 14px;
  color: #131f43;
  font-weight: 500;
}

.ag-header-cell-text {
  text-overflow: initial !important;
}

.ag-cell-label-container {
  height: auto !important;
}

.ag-theme-alpine .ag-row-odd {
  background-color: #f9fafb !important;
}

.ag-theme-alpine,
.ag-root.ag-layout-normal {
  font-family: 'Urbanist', sans-serif !important;
}

/* .ag-header-cell-label{
  text-overflow: initial !important;
  overflow: initial !important;
}

.ag-cell-value{
  text-overflow: initial !important;
  overflow: initial !important;
} */

/* @media only screen and (max-width: 400px) {
  .ag-theme-alpine .ag-header-cell{
    width: 91px !important;
  }
} */

/* .ag-root.ag-layout-normal{
  overflow: scroll;
} */

/*Ag grid Pagination*/

.ag-theme-alpine .ag-paging-panel {
  border-top: none !important;
  color: #60677e !important;
  font-size: 12px !important;
}
.ag-theme-alpine .ag-icon {
  color: #60677e !important;
}

.ag-theme-alpine .ag-paging-panel > * {
  margin: 0px -2px !important;
}

.ag-theme-alpine .ag-ltr .ag-cell {
  width: auto !important; /*table data cell width*/
  display: flex;
  align-items: center;
}

/*date range*/

.rdrCalendarWrapper {
  position: absolute;
  z-index: 1;
  box-shadow: rgb(149 157 165 / 20%) 0px 8px 24px;
}

.rdrStartEdge,
.rdrInRange,
.rdrEndEdge {
  color: #131f43 !important;
}

.rdrDateDisplayItemActive {
  border-color: #131f43 !important;
}

.react-date-picker__inputGroup__input,
.react-date-picker__inputGroup__divider {
  color: #60677e !important;
}

.react-time-picker__inputGroup__divider, 
.react-date-picker__inputGroup__divider {
  margin-right: 7px;
}

.react-date-picker__button svg {
  stroke: #60677e;
}
/* .react-date-picker button:first-child {
  display: none;
} */

.ag-theme-alpine .ag-ltr .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected) {
  border: none !important;
  border-color: none !important;
  outline: none !important;
}

/* .ag-theme-alpine .ag-row-selected{
  background: initial !important;
} */

/* .ag-theme-alpine .ag-row-hover{
  background: #fff !important;
} */

.ag-center-cols-viewport {
  height: calc(100% + 12px) !important;
}
.ag-center-cols-container {
  width: 100% !important;
}

.css-qc6sy-singleValue {
  color: #60677e !important;
}

.popup-arrow {
  display: none !important;
}

input[type='checkbox' i] {
  accent-color: #131f43 !important;
  vertical-align: middle;
}

input:focus {
  outline: none !important;
}

/* Add Green Button  */
body .addBtn {
  padding: 10px 20px;
  height: 44px;
  min-width: 140px;
  border: none;
  background-color: #38a169 !important;
  border-color: #38a169 !important;
  border-radius: 5px;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  gap: 6px;
}

body .addDltBtn {
  padding: 10px 20px;
  height: 44px;
  min-width: 140px;
  border: none;
  background-color: rgba(244, 11, 11, 0.788) !important;
  border-color: transparent !important;
  border-radius: 5px;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  gap: 6px;
}

.addBtn:hover {
  background-color: #207a4a;
}
.addDltBtn:hover {
  background-color: #7a2020;
}

.addBtnyellow {
  padding: 10px 20px;
  height: 44px;
  min-width: 140px;
  border: none;
  background-color: #ff9330 !important;
  border-color: #ff9330 !important;
  border-radius: 5px;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  gap: 6px;
}

.add_icon {
  margin-right: 5px;
  font-size: 20px;
  position: relative;
  top: 2px;
}

/* Search  */
.searchbar {
  min-width: 240px;
  min-height: 44px;
  border-radius: 5px;
  background-color: #fff;
  padding: 5px 5px 5px 40px;
  width: 100%;
}

.search_contain {
  position: relative;
}

.search_contain img {
  position: absolute;
  top: 14px;
  left: 15px;
}

::placeholder {
  font-size: 14px;
  font-weight: 600;
  color: #666666;
}

.table_top {
 display: flex;
    justify-content: flex-end;
    gap: 0;
    flex-direction: row;
}
.table_top1 {
  display: flex;
  justify-content: flex-end;
  gap: 0px;
}

/* Date range */
.date_range_main p {
  font-size: 14px;
  font-weight: 600;
  color: #727272;
  margin-bottom: 10px;
}
.date_range_contain {
  position: relative;
}
.date_btn {
  width: 50px;
  height: 44px;
  position: absolute;
  left: 0;
  padding: 0px;
  border: 0px;
  top: 0;
  background: transparent;
}
.date_btn img {
  width: 18px;
  position: relative;
  top: -1px;
}
.date_input {
  min-height: 44px;
  border: none;
  background-color: #fff;
  border-radius: 5px;
  min-width: 250px;
  padding-left: 50px;
  display: inline-flex;
  align-items: center;
}

/* Dropdown */
.drpdwn .drpdwn_btn {
  padding: 10px;
  min-width: 110px;
  border: none;
  background-color: #fff;
  border-radius: 5px;
  color: #888888;
  font-size: 16px;
  font-weight: 600;
}
.drpdwn .drpdwn_btn img {
  margin-left: 10px;
}
.drpdwn .drpdwn_btn:hover {
  background-color: #131f43;
}
.drpdwn .drpdwn_btn:focus {
  background-color: #131f43;
  box-shadow: none;
}

/* Form Head */
.form_head {
  display: flex;
  justify-content: space-between;
}

/* Form Container */
.form_container {
  padding: 30px 18px;
  margin-bottom: 20px;
}
.form_container label {
  font-size: 14px;
  font-weight: 600;
  color: #727272;
  margin-bottom: 12px !important;
}
.react-time-picker__wrapper {
  border: none !important;
  display: flex;
  flex-grow: 1;
  background-color: #f5f6fa;
  border-radius: 5px;
  min-height: 50px;
  width: 100% !important;
  color: #727272;
  font-size: 16px;
  font-weight: 500;
  flex-shrink: 0;
}
.react-time-picker {
  display: inline-flex;
  position: relative;
  width: 100%;
}
.react-time-picker button {
  display: none;
}
.react-time-picker__inputGroup {
  min-width: calc((4px * 3) + 0.54em * 6 + 0.217em * 2);
  flex-grow: 1;
  padding: 0 2px;
  box-sizing: content-box;
  display: flex;
  align-items: center;
}
.react-date-picker__clear-button {
  display: none !important;
}
.react-date-picker__wrapper {
  display: flex;
  flex-grow: 1;
  flex-shrink: 0;
  border: thin solid gray;
  flex-direction: row-reverse;
}
.form_container .form-field label {
  margin-bottom: 0px;
  position: relative;
  bottom: -2px;
}
.form_container .textarea_contain .form-field label {
  margin-bottom: 12px;
}
.form_container input {
  background-color: #f5f6fa;
  border-radius: 5px;
  min-height: 50px;
  border: none;
  padding: 10px;
  width: 100%;
  color: #727272;
  font-size: 16px;
  font-weight: 500;
}
.form_container textarea {
  background-color: #f5f6fa;
  border-radius: 5px;
  border: none;
  padding: 10px;
  width: 100%;
  color: #1d1d1d;
  font-size: 14px;
}
.form_container input[type='checkbox'] {
  background-color: #f5f6fa;
  border-radius: 5px;
  min-height: unset;
}
.form_container input::placeholder,
.form_container textarea::placeholder {
  color: #727272;
}
.form_container .form-group {
  margin-bottom: 23px;
}
.form_container .selectDrp {
  border: none !important;
  outline: none !important;
}
.form_container .selectDrp .css-b62m3t-container {
  position: relative;
}
.form_container .selectDrp .css-141b1tp-control:hover,
.form_container .selectDrp .css-1wa22fn-control:hover {
  cursor: pointer;
}
.form_container .selectDrp .css-b62m3t-container::after {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: inline-block;
  position: absolute;
  right: 25px;
  top: 13px;
}
.form_container .selectDrp .css-141b1tp-control,
.form_container .selectDrp .css-1wa22fn-control {
  background-color: #f5f6fa;
  border-radius: 5px;
  min-height: 50px;
  border: none;
}
.form_container .selectDrp .css-i0neym-control,
.form_container .selectDrp .css-2fuipi-control {
  min-height: 50px;
  background-color: #0f1824;
  color: #fff;
}
.form_container .selectDrp input {
  min-height: unset;
}
.form_container .selectDrp .css-1okebmr-indicatorSeparator {
  display: none;
}
.form_container .selectDrp .css-tlfecz-indicatorContainer svg {
  display: none;
}
.form_container .selectDrp .css-1gtu0rj-indicatorContainer svg {
  display: none;
}
.form_container .dateRange input {
  padding: 0px 10px;
  background-color: transparent;
}
.form_field_contain input {
  width: unset;
}
.addRole_container {
  padding: 25px 20px;
}
.addRole_container .add_input label {
  font-size: 14px;
  font-weight: 600;
  color: #727272;
  margin-bottom: 12px;
}
.addRole_container .add_input input {
  background-color: #f5f6fa;
  border-radius: 5px;
  min-height: 50px;
  border: none;
  padding: 10px;
  width: 100%;
  color: #1d1d1d;
  font-size: 14px;
}
.addRole_container .add_input input::placeholder {
  color: transparent;
}

/* Submit Button */
.sub_btn_create button {
  width: unset;
  padding: 13px 25px !important;
  min-width: auto;
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: #131f43;
  color: #fff;
  border: none;
  box-shadow: none;
  display: flex;
  gap: 5px;
  align-items: center;
}
.sub_btn_create button:hover {
  background-color: #142350;
}

.sub_btn input {
  width: unset;
  padding: 0 17px !important;
  min-width: auto;
  min-height: 50px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: #131f43;
  color: #fff;
  border: none;
  box-shadow: none;
  padding-left: 40px;
}
.sub_btn input:hover {
  background-color: #142350;
}

.sub_btn button {
  display: inline-flex;
  padding: 13px 25px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 5px;
  background: #131f43;
  color: var(--white, #fff);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  border: none;
  box-shadow: none;
}
.sub_btn button:hover {
  background-color: #142350;
}

.sub_btn {
  position: relative;
}
.sub_btn::after {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  display: block;
  position: absolute;
  left: 15px;
  top: -1px;
  pointer-events: none;
}

.sub_btn_update button {
  display: inline-flex;
  padding: 8px 25px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 5px;
  background: #131f43;
  color: var(--white, #fff);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  border: none;
  box-shadow: none;
}
.sub_btn_update button:hover {
  background-color: #142350;
}

body .btn-primary:hover {
  background-color: #131f43;
  border-color: #131f43;
  color: #f2f2f2 !important;
  fill: #131f43;
  border: 1px solid;
}

.sub_btn_del button {
  width: unset;
  padding: 13px 25px !important;
  min-width: auto;
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: #131f43;
  color: #fff;
  border: none;
  box-shadow: none;
  display: flex;
  gap: 5px;
  align-items: center;
}
.sub_btn_del button:hover {
  background-color: #142350;
}

.sub_btn1 input {
  width: unset;
  min-width: 140px;
  min-height: 50px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: #131f43;
  color: #fff;
  border: none;
  box-shadow: none;
  padding-left: 40px;
}
.sub_btn1 input:hover {
  background-color: #142350;
}
.sub_btn1 {
  position: relative;
}
.sub_btn1::after {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;
  display: block;
  position: absolute;
  left: 30px;
  top: -1px;
  pointer-events: none;
}

.sub_btn2 input {
  width: unset;
  min-width: 140px;
  min-height: 50px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: #131f43;
  color: #fff;
  border: none;
  box-shadow: none;
  padding-left: 40px;
}
.sub_btn2 input:hover {
  background-color: #142350;
}
.sub_btn2 {
  position: relative;
}
.sub_btn2::after {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) !important;
  display: block;
  position: absolute;
  left: 25px;
  top: -1px;
  pointer-events: none;
}
/* SERACH */
.ser_btn input {
  width: auto; /* The width adapts based on the content length */
  min-width: 140px;
  min-height: 50px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: #131f43;
  color: #fff;
  border: none;
  box-shadow: none;
  padding-left: 50px;
  margin-top: 34px;
  text-align: left;
  padding-right: 20px;
}

.ser_btn input:hover {
  background-color: #142350;
}

.ser_btn {
  position: relative;
  display: inline-block;
}

.ser_btn::after {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  display: block;
  position: absolute;
  left: 15px;
  top: 57%;
  pointer-events: none;
}

.updateBtn input {
  padding: 0px;
}
.updateBtn::after {
  content: '';
}
/* Reset Button */
.resetBtn {
  min-width: 140px;
  min-height: 50px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #131f43;
  color: #131f43;
  box-shadow: none;
}
.resetBtn:hover {
  background-color: #131f43;
  color: #fff;
}

/* Back Button */
.backBtn {
  width: 100px;
  height: 50px;
  background-color: #fff;
  border-radius: 5px;
  color: #000;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}
.backBtn:hover {
  cursor: pointer;
}

/* Tab */
.tabNav {
  background-color: transparent !important;
  box-shadow: none !important;
}
.tabNav li.nav-item {
  margin-right: 8px;
}
.tabNav li a {
  background-color: #fff;
  border-radius: 5px;
  padding: 10px 15px;
  font-size: 16px;
  font-weight: 500;
  color: #767676;
}

.profile_conatiner {
  padding-top: 0px !important;
}

.edit_btn {
  min-width: 140px;
  height: 50px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
}

.subLink {
  line-height: 50px;
  width: 100%;
  display: block;
  padding-left: 15px;
  display: grid;
  grid-template-columns: max-content max-content;
  align-items: center;
  column-gap: 1.2rem;
  transition: 0.3s;
  cursor: pointer;
  text-decoration: none;
  font-size: 16px;
  font-weight: 600;
}

.profile_view_container {
  padding: 25px 20px;
  
}
.profile_view_container span {
  font-size: 14px;
  font-weight: 600;
  color: #727272;
  margin-bottom: 12px;
  display: inline-block;
}

.css-i0neym-control .css-qc6sy-singleValue,
.css-i0neym-control .css-1k31n9l-placeholder,
.css-2fuipi-control .css-qc6sy-singleValue,
.css-2fuipi-control .css-1k31n9l-placeholder {
  color: #fff !important;
}

.css-1k31n9l-placeholder,
.css-qc6sy-singleValue {
  font-size: 16px !important;
  font-weight: 500 !important;
  color: #727272 !important;
}

body .cancl_btn:hover {
  color: #131f43 !important;
}


input[type="search"]::-webkit-search-cancel-button {

  cursor: pointer;
}

.pay_btn {
  height: 44px;
}

.pay_btn svg {
  margin-right: 10px;
}

.pay_modal .modal-dialog {
  max-width: 460px;
  min-height: auto;
  margin: 1.75rem auto;
  height: auto;
  max-height: calc(100vh - 60px);
}

.pay_modal .modal-content {
  border-radius: 54px;
  padding: 50px;
  max-height: calc(100vh - 90px);
  overflow: hidden;
}

.pay_modal .modal-header {
  padding: 0px;
}

.pay_modal .modal-header .modal-title {
  color: #0B0D0F;
  font-size: 22px;
  font-weight: 700;
}

.instruct_modal .modal-dialog {
  min-height: auto;
  height: calc(100vh - 60px);
}

.instruct_modal .modal-content {
    border-radius: 54px;
    height: calc(100vh - 90px);
    overflow: hidden;
    padding: 30px 50px 20px 50px;
}

.instruct_modal .modal-title {
    color: #38a169;
    font-size: 20px;
    font-weight: 700;
}

@media only screen and (min-width: 991px) {
  .mob-back {
    display: none;
  }
  .web-back {
    display: flex;
  }
}
@media only screen and (max-width: 992px) {
  .pagination {
    display: flex;
    /* padding-left: 100px !important; */
    list-style: none;
    /* justify-content: center !important; */
    overflow: auto !important;
}
  .instruct_modal .modal-content {
    padding: 20px 30px;
    border-radius: 10px;
  }
  .table_top {
    flex-direction: column;
    align-items: baseline;
    gap: 15px;
    margin-top: 30px;
  }
  .table_top .searchbar{
    width: 220px;
    min-width: 220px;
  }
  .table_top .addBtnyellow, 
  .table_top .addBtn{
    font-size: 14px;
  }
  .mob-back {
    display: flex;
  }
  .web-back {
    display: none;
  }
  .form_wrapper {
    display: flex;
    flex-flow: column;
  }
  .form_wrapper :nth-child(2) {
    order: 3;
  }
  .form_head {
    margin-top: 15px;
  }
  .form_wrapper :nth-child(3) {
    order: 2;
  }
  .date_range_main .date_input {
    width: 100%;
    min-width: auto;
  }
  .dropTopMain.dropTopMainWrap {
    margin-top: 30px !important;
  }
  .dropTopMain .dropdown,
  .dropTopMain .btn {
    width: 100%;
  }
  .form_container {
    margin-bottom: 10px !important;
  }
}
@media only screen and (max-width: 767px) {
  .dropTopMain.dropTopMainWrap {
    margin-top: 0px !important;
  }
  .dropTopMain .drpdwn {
    margin-bottom: 15px;
  }
  .table_top .search_contain.mr-1 {
    margin-right: 0px !important;
  }
  .table_top1 .search_contain.mr-1 {
    margin-right: 0px !important;
  }
}

@media only screen and (max-width: 600px) {
  .searchbar {
    min-width: unset;
  }
  .table_top {
    display: block;
  }
  .table_top1 {
    display: block;
  }
  .form_head {
    gap: 20px;
    flex-direction: column;
  }

  .ser_btn::after {
    top: 20%;
  }

  .ser_btn.search_cstm_btn input {
    margin-top: 0;
    margin-bottom: 15px;
  }
  .form_container .numb_sec .form-field label {
    margin-bottom: 12px;
  }
}



@media only screen and (max-width: 320px) {
  .pay_modal .modal-content {
    border-radius: 20px;
    padding: 30px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAGA;;;wDAGwD;;AAExD,uBAAuB;AACvB;EACE,gEAAgE;EAChE,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,wCAAwC;AACxC;;;EAGE,gEAAgE;AAClE;;AAEA,iCAAiC;AACjC;;EAEE,gEAAgE;AAClE;;AAEA,2DAA2D;AAC3D;EACE,gEAAgE;AAClE;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;;GAEG;AACH;;;;;;;;;;;;;;;;;GAiBG;AACH;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,8BAA8B;EAC9B,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,UAAU;EACV,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,gBAAgB;;AAEhB;EACE,uBAAuB;EACvB,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,yCAAyC;EACzC,2BAA2B;EAC3B,uBAAuB;EACvB,iCAAiC;EACjC,8BAA8B;AAChC;AACA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;;;;;;;;GAQG;;AAEH;;;;GAIG;;AAEH;;GAEG;;AAEH,qBAAqB;;AAErB;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB,EAAE,wBAAwB;EAChD,aAAa;EACb,mBAAmB;AACrB;;AAEA,aAAa;;AAEb;EACE,kBAAkB;EAClB,UAAU;EACV,+CAA+C;AACjD;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;AACA;;GAEG;;AAEH;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;EACE,oCAAoC;AACtC;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,gCAAgC;EAChC,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,qDAAqD;EACrD,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,gCAAgC;EAChC,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,QAAQ;AACV;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;CACC,aAAa;IACV,yBAAyB;IACzB,MAAM;IACN,mBAAmB;AACvB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA,eAAe;AACf;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,WAAW;EACX,MAAM;EACN,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,8BAA8B;AAChC;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,qDAAqD;EACrD,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,cAAc;EACd,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,gDAA0C;EAC1C,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AACA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;AACA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,gDAAwC;EACxC,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,2DAAoD;EACpD,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,2DAAoD;EACpD,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,oBAAoB;AACtB;AACA,WAAW;AACX;EACE,WAAW,EAAE,iDAAiD;EAC9D,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gDAA4C;EAC5C,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;;AAEA,QAAQ;AACR;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,8CAA8C;EAC9C,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;;AAEpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;;EAEE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;;EAEE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;IACb,oCAAoC;IACpC,gBAAgB;IAChB,wCAAwC;IACxC,yBAAyB;AAC7B;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,qBAAqB;IACrB,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,gBAAgB;EAClB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,QAAQ;EACV;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,2BAA2B;EAC7B;EACA;;IAEE,WAAW;EACb;EACA;IACE,8BAA8B;EAChC;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;;;AAIA;EACE;IACE,mBAAmB;IACnB,aAAa;EACf;AACF","sourcesContent":["@import '/src/styles/Variables/Variables.scss';\n@import '/src/styles/fonts/lufga.css';\n\n/* ===================================================\n   LUFGA FONT - GLOBAL APPLICATION\n   Using Plus Jakarta Sans as close alternative until Lufga files are added\n   =================================================== */\n\n/* Apply font to body */\nbody {\n  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;\n  font-weight: 400;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* Apply font to all elements globally */\n*,\n*::before,\n*::after {\n  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;\n}\n\n/* Ensure headings use the font */\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;\n}\n\n/* Ensure inputs, buttons, and form elements use the font */\ninput, button, select, textarea, label, span, p, div, a {\n  font-family: 'Plus Jakarta Sans', 'Lufga', sans-serif !important;\n}\n\n.page-item.disabled .page-link {\n  color: #6c757d;\n  pointer-events: none;\n  background-color: #fff;\n  border: none;\n  color: #303b5a !important;\n  font-size: 14px !important;\n  font-style: normal;\n  font-weight: 600 !important;\n  line-height: normal;\n}\n.PhoneInput {\n  display: flex;\n  align-items: center;\n  margin-bottom: 16px !important;\n}\n/* .App {\n  text-align: center;\n} */\n/* :root {\n  --black: #000;\n  --white: #f5f5f5;\n}\n\nbody{\n  background: var(--background-color);\n  color: var(--text-color);\n}\n\nbody.light{\n  --background-color: var(--white);\n  --text-color:var(--black);\n}\nbody.dark{\n  --background-color: var(--black);\n  --text-color:var(--white);\n} */\nth:first-child {\n  border-radius: 0px;\n  position: unset !important;\n  width: auto;\n}\n.rbt-input-multi .rbt-input-wrapper {\n  align-items: center !important;\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: -4px;\n  margin-top: -1px;\n  overflow: hidden;\n}\n.searchwrapsec .row {\n  align-items: center;\n}\nhr {\n  border-top: 1px dashed red !important;\n}\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.mr-1 {\n  margin-right: 10px !important;\n}\n.ml-1 {\n  margin-left: 10px !important;\n}\n.mb-20 {\n  margin-bottom: 20px;\n}\n\n.cookie-banner {\n  position: fixed;\n  bottom: 10px;\n  left: 10%;\n  right: 10%;\n  width: 80%;\n  color: #babfc7;\n  padding: 5px 9px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #050420;\n  border-radius: 5px;\n  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);\n}\n\n.cookie-banner p {\n  margin-bottom: 0px;\n  font-size: 13px;\n}\n\n.close {\n  height: 30px;\n  width: 130px;\n  font-size: 11px;\n  background-color: #32c167;\n  border: none;\n  color: #fff;\n  border-radius: 2px;\n  cursor: pointer;\n}\n\n.react-confirm-alert-overlay {\n  background-color: #0e1726ba !important;\n}\n\n.react-confirm-alert-body > h1 {\n  color: #0e1726e0 !important;\n  text-align: center !important;\n  font-size: 24px !important;\n}\n\n.react-confirm-alert-body {\n  background: #fff !important;\n  color: #0e1726e0 !important;\n  text-align: center !important;\n  font-size: 14px !important;\n  font-weight: bold;\n}\n\n.react-confirm-alert-button-group {\n  justify-content: center !important;\n}\n.react-confirm-alert-button-group > button {\n  background: #131f43 !important;\n  color: #fff !important;\n}\n\n.react-date-picker__wrapper {\n  border: none !important;\n  padding: 0px 10px;\n}\n\n/*Ag grid Table*/\n\n.ag-theme-alpine .ag-root-wrapper {\n  border: none !important;\n  background: transparent !important;\n  text-overflow: initial !important;\n}\n\n.ag-theme-alpine .ag-header {\n  border-bottom: none !important;\n  margin-bottom: 0px;\n  border-radius: 5px 5px 0px 0px !important;\n  min-height: 45px !important;\n  border: none !important;\n  text-overflow: initial !important;\n  background: #131f43 !important;\n}\n.ag-theme-alpine .ag-row {\n  height: 63px !important;\n  border-radius: 0px !important;\n  padding-top: 0px !important;\n  font-size: 14px;\n  color: #131f43;\n  font-weight: 500;\n}\n\n.ag-header-cell-text {\n  text-overflow: initial !important;\n}\n\n.ag-cell-label-container {\n  height: auto !important;\n}\n\n.ag-theme-alpine .ag-row-odd {\n  background-color: #f9fafb !important;\n}\n\n.ag-theme-alpine,\n.ag-root.ag-layout-normal {\n  font-family: 'Urbanist', sans-serif !important;\n}\n\n/* .ag-header-cell-label{\n  text-overflow: initial !important;\n  overflow: initial !important;\n}\n\n.ag-cell-value{\n  text-overflow: initial !important;\n  overflow: initial !important;\n} */\n\n/* @media only screen and (max-width: 400px) {\n  .ag-theme-alpine .ag-header-cell{\n    width: 91px !important;\n  }\n} */\n\n/* .ag-root.ag-layout-normal{\n  overflow: scroll;\n} */\n\n/*Ag grid Pagination*/\n\n.ag-theme-alpine .ag-paging-panel {\n  border-top: none !important;\n  color: #60677e !important;\n  font-size: 12px !important;\n}\n.ag-theme-alpine .ag-icon {\n  color: #60677e !important;\n}\n\n.ag-theme-alpine .ag-paging-panel > * {\n  margin: 0px -2px !important;\n}\n\n.ag-theme-alpine .ag-ltr .ag-cell {\n  width: auto !important; /*table data cell width*/\n  display: flex;\n  align-items: center;\n}\n\n/*date range*/\n\n.rdrCalendarWrapper {\n  position: absolute;\n  z-index: 1;\n  box-shadow: rgb(149 157 165 / 20%) 0px 8px 24px;\n}\n\n.rdrStartEdge,\n.rdrInRange,\n.rdrEndEdge {\n  color: #131f43 !important;\n}\n\n.rdrDateDisplayItemActive {\n  border-color: #131f43 !important;\n}\n\n.react-date-picker__inputGroup__input,\n.react-date-picker__inputGroup__divider {\n  color: #60677e !important;\n}\n\n.react-time-picker__inputGroup__divider, \n.react-date-picker__inputGroup__divider {\n  margin-right: 7px;\n}\n\n.react-date-picker__button svg {\n  stroke: #60677e;\n}\n/* .react-date-picker button:first-child {\n  display: none;\n} */\n\n.ag-theme-alpine .ag-ltr .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected) {\n  border: none !important;\n  border-color: none !important;\n  outline: none !important;\n}\n\n/* .ag-theme-alpine .ag-row-selected{\n  background: initial !important;\n} */\n\n/* .ag-theme-alpine .ag-row-hover{\n  background: #fff !important;\n} */\n\n.ag-center-cols-viewport {\n  height: calc(100% + 12px) !important;\n}\n.ag-center-cols-container {\n  width: 100% !important;\n}\n\n.css-qc6sy-singleValue {\n  color: #60677e !important;\n}\n\n.popup-arrow {\n  display: none !important;\n}\n\ninput[type='checkbox' i] {\n  accent-color: #131f43 !important;\n  vertical-align: middle;\n}\n\ninput:focus {\n  outline: none !important;\n}\n\n/* Add Green Button  */\nbody .addBtn {\n  padding: 10px 20px;\n  height: 44px;\n  min-width: 140px;\n  border: none;\n  background-color: #38a169 !important;\n  border-color: #38a169 !important;\n  border-radius: 5px;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n  gap: 6px;\n}\n\nbody .addDltBtn {\n  padding: 10px 20px;\n  height: 44px;\n  min-width: 140px;\n  border: none;\n  background-color: rgba(244, 11, 11, 0.788) !important;\n  border-color: transparent !important;\n  border-radius: 5px;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n  gap: 6px;\n}\n\n.addBtn:hover {\n  background-color: #207a4a;\n}\n.addDltBtn:hover {\n  background-color: #7a2020;\n}\n\n.addBtnyellow {\n  padding: 10px 20px;\n  height: 44px;\n  min-width: 140px;\n  border: none;\n  background-color: #ff9330 !important;\n  border-color: #ff9330 !important;\n  border-radius: 5px;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n  gap: 6px;\n}\n\n.add_icon {\n  margin-right: 5px;\n  font-size: 20px;\n  position: relative;\n  top: 2px;\n}\n\n/* Search  */\n.searchbar {\n  min-width: 240px;\n  min-height: 44px;\n  border-radius: 5px;\n  background-color: #fff;\n  padding: 5px 5px 5px 40px;\n  width: 100%;\n}\n\n.search_contain {\n  position: relative;\n}\n\n.search_contain img {\n  position: absolute;\n  top: 14px;\n  left: 15px;\n}\n\n::placeholder {\n  font-size: 14px;\n  font-weight: 600;\n  color: #666666;\n}\n\n.table_top {\n display: flex;\n    justify-content: flex-end;\n    gap: 0;\n    flex-direction: row;\n}\n.table_top1 {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0px;\n}\n\n/* Date range */\n.date_range_main p {\n  font-size: 14px;\n  font-weight: 600;\n  color: #727272;\n  margin-bottom: 10px;\n}\n.date_range_contain {\n  position: relative;\n}\n.date_btn {\n  width: 50px;\n  height: 44px;\n  position: absolute;\n  left: 0;\n  padding: 0px;\n  border: 0px;\n  top: 0;\n  background: transparent;\n}\n.date_btn img {\n  width: 18px;\n  position: relative;\n  top: -1px;\n}\n.date_input {\n  min-height: 44px;\n  border: none;\n  background-color: #fff;\n  border-radius: 5px;\n  min-width: 250px;\n  padding-left: 50px;\n  display: inline-flex;\n  align-items: center;\n}\n\n/* Dropdown */\n.drpdwn .drpdwn_btn {\n  padding: 10px;\n  min-width: 110px;\n  border: none;\n  background-color: #fff;\n  border-radius: 5px;\n  color: #888888;\n  font-size: 16px;\n  font-weight: 600;\n}\n.drpdwn .drpdwn_btn img {\n  margin-left: 10px;\n}\n.drpdwn .drpdwn_btn:hover {\n  background-color: #131f43;\n}\n.drpdwn .drpdwn_btn:focus {\n  background-color: #131f43;\n  box-shadow: none;\n}\n\n/* Form Head */\n.form_head {\n  display: flex;\n  justify-content: space-between;\n}\n\n/* Form Container */\n.form_container {\n  padding: 30px 18px;\n  margin-bottom: 20px;\n}\n.form_container label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #727272;\n  margin-bottom: 12px !important;\n}\n.react-time-picker__wrapper {\n  border: none !important;\n  display: flex;\n  flex-grow: 1;\n  background-color: #f5f6fa;\n  border-radius: 5px;\n  min-height: 50px;\n  width: 100% !important;\n  color: #727272;\n  font-size: 16px;\n  font-weight: 500;\n  flex-shrink: 0;\n}\n.react-time-picker {\n  display: inline-flex;\n  position: relative;\n  width: 100%;\n}\n.react-time-picker button {\n  display: none;\n}\n.react-time-picker__inputGroup {\n  min-width: calc((4px * 3) + 0.54em * 6 + 0.217em * 2);\n  flex-grow: 1;\n  padding: 0 2px;\n  box-sizing: content-box;\n  display: flex;\n  align-items: center;\n}\n.react-date-picker__clear-button {\n  display: none !important;\n}\n.react-date-picker__wrapper {\n  display: flex;\n  flex-grow: 1;\n  flex-shrink: 0;\n  border: thin solid gray;\n  flex-direction: row-reverse;\n}\n.form_container .form-field label {\n  margin-bottom: 0px;\n  position: relative;\n  bottom: -2px;\n}\n.form_container .textarea_contain .form-field label {\n  margin-bottom: 12px;\n}\n.form_container input {\n  background-color: #f5f6fa;\n  border-radius: 5px;\n  min-height: 50px;\n  border: none;\n  padding: 10px;\n  width: 100%;\n  color: #727272;\n  font-size: 16px;\n  font-weight: 500;\n}\n.form_container textarea {\n  background-color: #f5f6fa;\n  border-radius: 5px;\n  border: none;\n  padding: 10px;\n  width: 100%;\n  color: #1d1d1d;\n  font-size: 14px;\n}\n.form_container input[type='checkbox'] {\n  background-color: #f5f6fa;\n  border-radius: 5px;\n  min-height: unset;\n}\n.form_container input::placeholder,\n.form_container textarea::placeholder {\n  color: #727272;\n}\n.form_container .form-group {\n  margin-bottom: 23px;\n}\n.form_container .selectDrp {\n  border: none !important;\n  outline: none !important;\n}\n.form_container .selectDrp .css-b62m3t-container {\n  position: relative;\n}\n.form_container .selectDrp .css-141b1tp-control:hover,\n.form_container .selectDrp .css-1wa22fn-control:hover {\n  cursor: pointer;\n}\n.form_container .selectDrp .css-b62m3t-container::after {\n  content: url(../src/assets/arrow_down.svg);\n  display: inline-block;\n  position: absolute;\n  right: 25px;\n  top: 13px;\n}\n.form_container .selectDrp .css-141b1tp-control,\n.form_container .selectDrp .css-1wa22fn-control {\n  background-color: #f5f6fa;\n  border-radius: 5px;\n  min-height: 50px;\n  border: none;\n}\n.form_container .selectDrp .css-i0neym-control,\n.form_container .selectDrp .css-2fuipi-control {\n  min-height: 50px;\n  background-color: #0f1824;\n  color: #fff;\n}\n.form_container .selectDrp input {\n  min-height: unset;\n}\n.form_container .selectDrp .css-1okebmr-indicatorSeparator {\n  display: none;\n}\n.form_container .selectDrp .css-tlfecz-indicatorContainer svg {\n  display: none;\n}\n.form_container .selectDrp .css-1gtu0rj-indicatorContainer svg {\n  display: none;\n}\n.form_container .dateRange input {\n  padding: 0px 10px;\n  background-color: transparent;\n}\n.form_field_contain input {\n  width: unset;\n}\n.addRole_container {\n  padding: 25px 20px;\n}\n.addRole_container .add_input label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #727272;\n  margin-bottom: 12px;\n}\n.addRole_container .add_input input {\n  background-color: #f5f6fa;\n  border-radius: 5px;\n  min-height: 50px;\n  border: none;\n  padding: 10px;\n  width: 100%;\n  color: #1d1d1d;\n  font-size: 14px;\n}\n.addRole_container .add_input input::placeholder {\n  color: transparent;\n}\n\n/* Submit Button */\n.sub_btn_create button {\n  width: unset;\n  padding: 13px 25px !important;\n  min-width: auto;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 5px;\n  background-color: #131f43;\n  color: #fff;\n  border: none;\n  box-shadow: none;\n  display: flex;\n  gap: 5px;\n  align-items: center;\n}\n.sub_btn_create button:hover {\n  background-color: #142350;\n}\n\n.sub_btn input {\n  width: unset;\n  padding: 0 17px !important;\n  min-width: auto;\n  min-height: 50px;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 5px;\n  background-color: #131f43;\n  color: #fff;\n  border: none;\n  box-shadow: none;\n  padding-left: 40px;\n}\n.sub_btn input:hover {\n  background-color: #142350;\n}\n\n.sub_btn button {\n  display: inline-flex;\n  padding: 13px 25px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 5px;\n  background: #131f43;\n  color: var(--white, #fff);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  border: none;\n  box-shadow: none;\n}\n.sub_btn button:hover {\n  background-color: #142350;\n}\n\n.sub_btn {\n  position: relative;\n}\n.sub_btn::after {\n  content: url('../src/assets/submit.svg');\n  display: block;\n  position: absolute;\n  left: 15px;\n  top: -1px;\n  pointer-events: none;\n}\n\n.sub_btn_update button {\n  display: inline-flex;\n  padding: 8px 25px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 5px;\n  background: #131f43;\n  color: var(--white, #fff);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  border: none;\n  box-shadow: none;\n}\n.sub_btn_update button:hover {\n  background-color: #142350;\n}\n\nbody .btn-primary:hover {\n  background-color: #131f43;\n  border-color: #131f43;\n  color: #f2f2f2 !important;\n  fill: #131f43;\n  border: 1px solid;\n}\n\n.sub_btn_del button {\n  width: unset;\n  padding: 13px 25px !important;\n  min-width: auto;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 5px;\n  background-color: #131f43;\n  color: #fff;\n  border: none;\n  box-shadow: none;\n  display: flex;\n  gap: 5px;\n  align-items: center;\n}\n.sub_btn_del button:hover {\n  background-color: #142350;\n}\n\n.sub_btn1 input {\n  width: unset;\n  min-width: 140px;\n  min-height: 50px;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 5px;\n  background-color: #131f43;\n  color: #fff;\n  border: none;\n  box-shadow: none;\n  padding-left: 40px;\n}\n.sub_btn1 input:hover {\n  background-color: #142350;\n}\n.sub_btn1 {\n  position: relative;\n}\n.sub_btn1::after {\n  content: url('../src/assets/edit-ed.svg') !important;\n  display: block;\n  position: absolute;\n  left: 30px;\n  top: -1px;\n  pointer-events: none;\n}\n\n.sub_btn2 input {\n  width: unset;\n  min-width: 140px;\n  min-height: 50px;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 5px;\n  background-color: #131f43;\n  color: #fff;\n  border: none;\n  box-shadow: none;\n  padding-left: 40px;\n}\n.sub_btn2 input:hover {\n  background-color: #142350;\n}\n.sub_btn2 {\n  position: relative;\n}\n.sub_btn2::after {\n  content: url('../src/assets/calloff.svg') !important;\n  display: block;\n  position: absolute;\n  left: 25px;\n  top: -1px;\n  pointer-events: none;\n}\n/* SERACH */\n.ser_btn input {\n  width: auto; /* The width adapts based on the content length */\n  min-width: 140px;\n  min-height: 50px;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 5px;\n  background-color: #131f43;\n  color: #fff;\n  border: none;\n  box-shadow: none;\n  padding-left: 50px;\n  margin-top: 34px;\n  text-align: left;\n  padding-right: 20px;\n}\n\n.ser_btn input:hover {\n  background-color: #142350;\n}\n\n.ser_btn {\n  position: relative;\n  display: inline-block;\n}\n\n.ser_btn::after {\n  content: url('../src/assets/SearchBold.svg');\n  display: block;\n  position: absolute;\n  left: 15px;\n  top: 57%;\n  pointer-events: none;\n}\n\n.updateBtn input {\n  padding: 0px;\n}\n.updateBtn::after {\n  content: '';\n}\n/* Reset Button */\n.resetBtn {\n  min-width: 140px;\n  min-height: 50px;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px #131f43;\n  color: #131f43;\n  box-shadow: none;\n}\n.resetBtn:hover {\n  background-color: #131f43;\n  color: #fff;\n}\n\n/* Back Button */\n.backBtn {\n  width: 100px;\n  height: 50px;\n  background-color: #fff;\n  border-radius: 5px;\n  color: #000;\n  font-size: 16px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.backBtn:hover {\n  cursor: pointer;\n}\n\n/* Tab */\n.tabNav {\n  background-color: transparent !important;\n  box-shadow: none !important;\n}\n.tabNav li.nav-item {\n  margin-right: 8px;\n}\n.tabNav li a {\n  background-color: #fff;\n  border-radius: 5px;\n  padding: 10px 15px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #767676;\n}\n\n.profile_conatiner {\n  padding-top: 0px !important;\n}\n\n.edit_btn {\n  min-width: 140px;\n  height: 50px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 5px;\n}\n\n.subLink {\n  line-height: 50px;\n  width: 100%;\n  display: block;\n  padding-left: 15px;\n  display: grid;\n  grid-template-columns: max-content max-content;\n  align-items: center;\n  column-gap: 1.2rem;\n  transition: 0.3s;\n  cursor: pointer;\n  text-decoration: none;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.profile_view_container {\n  padding: 25px 20px;\n  \n}\n.profile_view_container span {\n  font-size: 14px;\n  font-weight: 600;\n  color: #727272;\n  margin-bottom: 12px;\n  display: inline-block;\n}\n\n.css-i0neym-control .css-qc6sy-singleValue,\n.css-i0neym-control .css-1k31n9l-placeholder,\n.css-2fuipi-control .css-qc6sy-singleValue,\n.css-2fuipi-control .css-1k31n9l-placeholder {\n  color: #fff !important;\n}\n\n.css-1k31n9l-placeholder,\n.css-qc6sy-singleValue {\n  font-size: 16px !important;\n  font-weight: 500 !important;\n  color: #727272 !important;\n}\n\nbody .cancl_btn:hover {\n  color: #131f43 !important;\n}\n\n\ninput[type=\"search\"]::-webkit-search-cancel-button {\n\n  cursor: pointer;\n}\n\n.pay_btn {\n  height: 44px;\n}\n\n.pay_btn svg {\n  margin-right: 10px;\n}\n\n.pay_modal .modal-dialog {\n  max-width: 460px;\n  min-height: auto;\n  margin: 1.75rem auto;\n  height: auto;\n  max-height: calc(100vh - 60px);\n}\n\n.pay_modal .modal-content {\n  border-radius: 54px;\n  padding: 50px;\n  max-height: calc(100vh - 90px);\n  overflow: hidden;\n}\n\n.pay_modal .modal-header {\n  padding: 0px;\n}\n\n.pay_modal .modal-header .modal-title {\n  color: #0B0D0F;\n  font-size: 22px;\n  font-weight: 700;\n}\n\n.instruct_modal .modal-dialog {\n  min-height: auto;\n  height: calc(100vh - 60px);\n}\n\n.instruct_modal .modal-content {\n    border-radius: 54px;\n    height: calc(100vh - 90px);\n    overflow: hidden;\n    padding: 30px 50px 20px 50px;\n}\n\n.instruct_modal .modal-title {\n    color: #38a169;\n    font-size: 20px;\n    font-weight: 700;\n}\n\n@media only screen and (min-width: 991px) {\n  .mob-back {\n    display: none;\n  }\n  .web-back {\n    display: flex;\n  }\n}\n@media only screen and (max-width: 992px) {\n  .pagination {\n    display: flex;\n    /* padding-left: 100px !important; */\n    list-style: none;\n    /* justify-content: center !important; */\n    overflow: auto !important;\n}\n  .instruct_modal .modal-content {\n    padding: 20px 30px;\n    border-radius: 10px;\n  }\n  .table_top {\n    flex-direction: column;\n    align-items: baseline;\n    gap: 15px;\n    margin-top: 30px;\n  }\n  .table_top .searchbar{\n    width: 220px;\n    min-width: 220px;\n  }\n  .table_top .addBtnyellow, \n  .table_top .addBtn{\n    font-size: 14px;\n  }\n  .mob-back {\n    display: flex;\n  }\n  .web-back {\n    display: none;\n  }\n  .form_wrapper {\n    display: flex;\n    flex-flow: column;\n  }\n  .form_wrapper :nth-child(2) {\n    order: 3;\n  }\n  .form_head {\n    margin-top: 15px;\n  }\n  .form_wrapper :nth-child(3) {\n    order: 2;\n  }\n  .date_range_main .date_input {\n    width: 100%;\n    min-width: auto;\n  }\n  .dropTopMain.dropTopMainWrap {\n    margin-top: 30px !important;\n  }\n  .dropTopMain .dropdown,\n  .dropTopMain .btn {\n    width: 100%;\n  }\n  .form_container {\n    margin-bottom: 10px !important;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .dropTopMain.dropTopMainWrap {\n    margin-top: 0px !important;\n  }\n  .dropTopMain .drpdwn {\n    margin-bottom: 15px;\n  }\n  .table_top .search_contain.mr-1 {\n    margin-right: 0px !important;\n  }\n  .table_top1 .search_contain.mr-1 {\n    margin-right: 0px !important;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .searchbar {\n    min-width: unset;\n  }\n  .table_top {\n    display: block;\n  }\n  .table_top1 {\n    display: block;\n  }\n  .form_head {\n    gap: 20px;\n    flex-direction: column;\n  }\n\n  .ser_btn::after {\n    top: 20%;\n  }\n\n  .ser_btn.search_cstm_btn input {\n    margin-top: 0;\n    margin-bottom: 15px;\n  }\n  .form_container .numb_sec .form-field label {\n    margin-bottom: 12px;\n  }\n}\n\n\n\n@media only screen and (max-width: 320px) {\n  .pay_modal .modal-content {\n    border-radius: 20px;\n    padding: 30px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
